module.exports = __webpack_public_path__ + "img/index-logo.6a243ada.png";